export const socialsData = {
    github: 'https://github.com/SiriusGroza1413',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/guillermo-ojeda-140742208/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}